<div class="card app-card">
	<div class="card-body">
		<div class="row mb-2" *ngIf="filters.length > 0">
			<div class="col-3 mb-3">
				<div class="input-group" #filterInput="ngbDropdown" ngbDropdown>  <!-- [autoClose]="'inside'" -->
					<input ngbDropdownToggle  type="text" class="form-control" placeholder="Filter" [readOnly]="allFiltersUsed()" [formControl]="formControl" (keypress)="filterInput.open()">

					<fa-icon [icon]="faFilter" class="input-group-text" *ngIf="filterModal" (click)="showFilterModal()">
					</fa-icon>
					<button class="btn btn-light input-group-text" *ngIf="showSearchHelp" (click)="onShowSearchHelpClicked.emit({})">
						<i nz-icon nzType="question-circle"></i>
					</button>

					<ul class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
						<ng-container  *ngFor="let filter of filters">
							<li *ngIf="!filter.value" ngbDropdownItem [disabled]="isFormFilterValueInvalid(filter)">
								<button class="dropdown-item" (click)="addFilter(filter)" [disabled]="isFormFilterValueInvalid(filter)" >
									<i>Search By </i>  <b> {{filter.label}}: {{formControl.value}}</b>
								</button>
							</li>
						</ng-container>
					</ul>
				</div>
				<small class="text-secondary" *ngIf="loading == false && _data && _data.filtersToOpen == true && anyFiltersUsed() == false">Provide filters to query</small>
				<small class="text-danger" *ngIf="loading == false && _data && _data.filtersToOpen == true && anyFiltersUsed() == true">Filters are not specific enough</small>
			</div>
			<div class="col pt-1">
				<ng-container *ngFor="let filter of filters">
					<nz-tag
						*ngIf="filter.value"
						nzMode="closeable"
						(nzOnClose)="removeFilter(filter)"
						style="font-size: 1em;"
						class="pt-1 pb-1">
						{{filter.label}}: {{filter.value}}
					</nz-tag>
				</ng-container>
			</div>
		</div>
		<div class="row">
			<div class="col">
					<div class="d-flex justify-content-end gap-2">
						<app-pdf-export-button *ngIf="contentToPrintElement" [resource]="contentToPrintElement" [name]="downloadName" [heading]="downloadHeading"></app-pdf-export-button>
						<button class="btn btn-sm btn-ghost" (click)="exportCsv()" >
							<span nz-icon nzType="file-pdf" nzTheme="outline"></span>Export CSV
						</button>
					</div>

					<div #contentToPrint>
						<nz-table
							#basicTable
							[ngClass]="headerClass+'-zorro'"
							[ngClass]="headerClass+'-zorro'"
							[nzData]="data?.records??[]"
							[nzLoading]="loading"
							[nzFrontPagination]="!disablePaging"
							[nzTotal]="data?.recordCount??0"
							[nzPageIndex]="(data?.pageNumber??0)+1"
							[nzPageSize]="data?.pageLength??20"
							[nzPageSizeOptions]="[5,10,15,20]"
							[nzShowSizeChanger]="!disablePaging"
							[nzShowPagination]="!disablePaging"
							(nzQueryParams)="onPageChange($event)">

							<thead>
								<tr>
									<th *ngFor="let column of columns; trackBy: trackByColumn">
										{{column.title}}
									</th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let row of basicTable.data; let last = last; trackBy: trackByRow" (click)="onClick(row)" [ngClass]="{'cursor-pointer': isClickable(row), 'bold-last-row': boldLastRow && last}">
									<td *ngFor="let column of columns; trackBy: trackByColumn">
										<ng-container *ngIf="getTemplate(column); else defaultCell">
											<ng-container *ngTemplateOutlet="getTemplate(column); context: { row: row, value: getRowValue(row,column) }"></ng-container>
										</ng-container>
										<ng-template #defaultCell>
											{{ getRowValue(row,column) }}
										</ng-template>
									</td>
								</tr>
							</tbody>
						</nz-table>
				</div>
			</div>
		</div>
	</div>
</div>
